// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__q2iRp","col":"Table_col__1lJR8","fulfillmentStatus":"Table_fulfillmentStatus__3xv1C","emailCol":"Table_emailCol__1b572"};